// Language picker dialog: one card per UI language showing its country flag and its
// NATIVE name (a child who got stuck in the wrong language can still find their own —
// a Thai speaker looks for "ไทย" no matter what the current UI language says).
import i18next from 'i18next';
import { openChoicePicker } from './choicePicker';
import { SUPPORTED_LANGS, LANG_FLAG, LANG_NATIVE, type Lang } from '@/i18n';

export function openLanguagePicker(current: Lang, onSelect: (lang: Lang) => void): void {
  openChoicePicker(
    i18next.t('menu.langChoose'),
    SUPPORTED_LANGS.map((lang) => ({
      id: lang,
      tileHtml: `<span class="picker__flag">${LANG_FLAG[lang]}</span>`,
      name: LANG_NATIVE[lang],
    })),
    current,
    (id) => onSelect(id as Lang),
  );
}
